if (!customElements.get('customer-reviews')) {
  class CustomerReviews extends HTMLElement {
    constructor() {
      super();

      if (this.dataset.contentSource === 'judgeme') return;

      this.viewport = this.querySelector('.customer-reviews__viewport');
      this.previousButton = this.querySelector('.customer-reviews__arrow--previous');
      this.nextButton = this.querySelector('.customer-reviews__arrow--next');
      this.card = this.querySelector('.customer-reviews__review');

      if (!this.viewport || !this.previousButton || !this.nextButton || !this.card) return;

      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.handlePrevious = () => this.scrollByCard(-1);
      this.handleNext = () => this.scrollByCard(1);
      this.handleScroll = () => this.queueControlUpdate();
      this.handleResize = () => this.queueControlUpdate();

      this.previousButton.addEventListener('click', this.handlePrevious);
      this.nextButton.addEventListener('click', this.handleNext);
      this.viewport.addEventListener('scroll', this.handleScroll, { passive: true });
      window.addEventListener('resize', this.handleResize);
      this.resizeObserver = new ResizeObserver(this.handleResize);
      this.resizeObserver.observe(this.viewport);
      this.resizeObserver.observe(this.querySelector('.customer-reviews__track'));
      requestAnimationFrame(() => this.updateControls());
    }

    disconnectedCallback() {
      this.previousButton?.removeEventListener('click', this.handlePrevious);
      this.nextButton?.removeEventListener('click', this.handleNext);
      this.viewport?.removeEventListener('scroll', this.handleScroll);
      window.removeEventListener('resize', this.handleResize);
      this.resizeObserver?.disconnect();
      cancelAnimationFrame(this.updateFrame);
    }

    scrollByCard(direction) {
      const track = this.querySelector('.customer-reviews__track');
      const gap = Number.parseFloat(getComputedStyle(track).columnGap) || 0;
      const distance = this.card.getBoundingClientRect().width + gap;

      this.viewport.scrollBy({
        left: direction * distance,
        behavior: this.reducedMotion.matches ? 'auto' : 'smooth',
      });
    }

    queueControlUpdate() {
      cancelAnimationFrame(this.updateFrame);
      this.updateFrame = requestAnimationFrame(() => this.updateControls());
    }

    updateControls() {
      const maximumScroll = Math.max(0, this.viewport.scrollWidth - this.viewport.clientWidth);
      const atStart = this.viewport.scrollLeft <= 2;
      const atEnd = this.viewport.scrollLeft >= maximumScroll - 2;

      this.previousButton.disabled = atStart;
      this.previousButton.setAttribute('aria-disabled', String(atStart));
      this.nextButton.disabled = atEnd;
      this.nextButton.setAttribute('aria-disabled', String(atEnd));
    }
  }

  customElements.define('customer-reviews', CustomerReviews);
}
